import { useGlobalInfo } from '@/hooks/context/useGlobalInfo';
import useTranslation from 'next-translate/useTranslation';

//components
import { SwitchRightMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu/Components/SwitchRightMenu';

export function SideBarHeader() {
    const { globalInfo } = useGlobalInfo();
    const { t } = useTranslation('commons');

    return (
        <div className="flex w-full items-center justify-between bg-icoGray-100 p-8 dark:bg-icoDarkMode-anthracite">
            <span className="font-GBold text-xl" data-testid="selected-option-name">
                {globalInfo.menuGroupActive ? t('menu.groups') : t('menu.social_profiles')}
            </span>
            <SwitchRightMenu iconSize="text-sm" />
        </div>
    );
}
